/* Buffalo House borderless product UI and empty-review fallback. */
(function () {
  'use strict';

  var scheduled = false;

  function emptyStarsMarkup() {
    var star = '<span class="bh-rating__star">' +
      '<svg class="bh-rating__star-outline" viewBox="0 0 16 16" aria-hidden="true">' +
      '<path d="M8 1.25 10.06 5.42 14.66 6.09 11.33 9.33 12.12 13.91 8 11.75 3.88 13.91 4.67 9.33 1.34 6.09 5.94 5.42 8 1.25Z"></path>' +
      '</svg>' +
      '<span class="bh-rating__star-fill" style="width:0%">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1.25 10.06 5.42 14.66 6.09 11.33 9.33 12.12 13.91 8 11.75 3.88 13.91 4.67 9.33 1.34 6.09 5.94 5.42 8 1.25Z"></path></svg>' +
      '</span></span>';
    return star + star + star + star + star;
  }

  function nativeStarsAreVisible(infoCard) {
    var nativeStars = infoCard.querySelector('.jdgm-prev-badge__stars');
    if (!nativeStars) return false;
    var style = window.getComputedStyle(nativeStars);
    var rect = nativeStars.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function ensurePdpEmptyRating() {
    var infoCard = document.querySelector('.pdp-info-card');
    if (!infoCard) return;

    var title = infoCard.querySelector('.pdp-title');
    if (!title) return;

    var fallback = infoCard.querySelector('.bh-rating--pdp-fallback');
    var customRating = infoCard.querySelector('.bh-rating:not(.bh-rating--pdp-fallback)');

    if (customRating || nativeStarsAreVisible(infoCard)) {
      if (fallback) fallback.remove();
      return;
    }

    if (!fallback) {
      fallback = document.createElement('a');
      fallback.className = 'bh-rating bh-rating--pdp bh-rating--empty bh-rating--pdp-fallback';
      fallback.href = '#judgeme_product_reviews';
      fallback.setAttribute('aria-label', 'No Judge.me reviews yet');
      fallback.innerHTML = '<span class="bh-rating__stars" aria-hidden="true">' + emptyStarsMarkup() + '</span>';
      infoCard.insertBefore(fallback, title);
    } else if (fallback.nextElementSibling !== title) {
      infoCard.insertBefore(fallback, title);
    }
  }

  function run() {
    ensurePdpEmptyRating();
  }

  function queueRun() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  var observer = new MutationObserver(queueRun);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  window.setTimeout(queueRun, 500);
  window.setTimeout(queueRun, 1600);
  window.setTimeout(queueRun, 3200);
})();
